/**
 * CRM Dashboard Page
 *
 * This is a placeholder component - the actual CRM iframe is rendered
 * by PersistentCrm in MainLayout to keep it mounted across navigation.
 *
 * This component exists only to:
 * 1. Satisfy the router (so /crm is a valid route)
 * 2. Provide a fallback if PersistentCrm hasn't mounted yet
 *
 * The PersistentCrm component shows/hides itself based on the route,
 * so this page renders nothing (the iframe is shown by the layout).
 */

export function CrmDashboardPage() {
  // PersistentCrm in MainLayout handles the actual iframe rendering
  // This component returns null since the layout takes care of everything
  return null;
}
